import Banner from "../../components/website/contactus/Banner";
import ContactUs from "../../components/website/contactus/ContactUs";

const ContactusPage = () => {
  return (
    <>
      <Banner />
      <ContactUs />
    </>
  );
};

export default ContactusPage;
